// extracted by mini-css-extract-plugin
export default {"nugget":"Nugget_nugget__FA3n4","imageContainer":"Nugget_imageContainer__pcMef","image":"Nugget_image__PyXmO"};